import { addMembersToOrganizationBulkActionEvent, changeMembersInOrganizationActionEvent, changeMembersRoleAndStatusBulkActionEvent, changeMembersRoleBulkActionEvent, removeMembersFromOrganizationBulkActionEvent, } from '../../../../backend/features/audit/shared';
import { defineAuditHandlers } from '@juvare/platform-sdk-react/ui/features/audit';
export const auditDetailsHandlers = defineAuditHandlers({
    [addMembersToOrganizationBulkActionEvent]: (event) => {
        var _a, _b, _c, _d, _e;
        return ({
            data: { orgRole: (_a = event.params) === null || _a === void 0 ? void 0 : _a.orgRole, orgStatus: (_b = event.params) === null || _b === void 0 ? void 0 : _b.orgStatus, ids: (_c = event.params) === null || _c === void 0 ? void 0 : _c.ids },
            entityAuditMapping: (_d = event.params) === null || _d === void 0 ? void 0 : _d.entityAuditMapping,
            auditColumnValue: (_e = event.params) === null || _e === void 0 ? void 0 : _e.auditColumnValue,
        });
    },
    [changeMembersRoleBulkActionEvent]: (event) => {
        var _a, _b, _c, _d;
        return ({
            data: { orgRole: (_a = event.params) === null || _a === void 0 ? void 0 : _a.orgRole, ids: (_b = event.params) === null || _b === void 0 ? void 0 : _b.ids },
            entityAuditMapping: (_c = event.params) === null || _c === void 0 ? void 0 : _c.entityAuditMapping,
            auditColumnValue: (_d = event.params) === null || _d === void 0 ? void 0 : _d.auditColumnValue,
        });
    },
    [changeMembersRoleAndStatusBulkActionEvent]: (event) => {
        var _a, _b, _c, _d, _e;
        return ({
            data: { orgRole: (_a = event.params) === null || _a === void 0 ? void 0 : _a.orgRole, orgStatus: (_b = event.params) === null || _b === void 0 ? void 0 : _b.orgStatus, ids: (_c = event.params) === null || _c === void 0 ? void 0 : _c.ids },
            entityAuditMapping: (_d = event.params) === null || _d === void 0 ? void 0 : _d.entityAuditMapping,
            auditColumnValue: (_e = event.params) === null || _e === void 0 ? void 0 : _e.auditColumnValue,
        });
    },
    [removeMembersFromOrganizationBulkActionEvent]: (event) => {
        var _a, _b, _c;
        return ({
            data: { ids: (_a = event.params) === null || _a === void 0 ? void 0 : _a.ids },
            entityAuditMapping: (_b = event.params) === null || _b === void 0 ? void 0 : _b.entityAuditMapping,
            auditColumnValue: (_c = event.params) === null || _c === void 0 ? void 0 : _c.auditColumnValue,
        });
    },
    [changeMembersInOrganizationActionEvent]: (event) => {
        var _a, _b, _c, _d;
        return ({
            data: Object.assign(Object.assign({}, event.params.data), { ids: (_a = event.params) === null || _a === void 0 ? void 0 : _a.ids }),
            prevData: (_b = event.params) === null || _b === void 0 ? void 0 : _b.prevData,
            entityAuditMapping: (_c = event.params) === null || _c === void 0 ? void 0 : _c.entityAuditMapping,
            auditColumnValue: (_d = event.params) === null || _d === void 0 ? void 0 : _d.auditColumnValue,
        });
    },
});
